import vacationsScheme from "@/forms/data/vacations";

export function timeslotsFilter(timeslots) {
  return timeslots
    .map(el => el.replace(/\s+/g, "").split("-"))
    .flat()
    .filter((value, index, self) => self.indexOf(value) === index);
}

export function vacationsNumbers(vacations) {
  return vacations
    .replace(/\s+/g, "")
    .toLowerCase()
    .split(",")
    .map(vacation => vacationsScheme[vacation]);
}

export function proceedOfficeVacations(vacations) {
  return vacations.map(weekDay => vacationsScheme[weekDay.toLowerCase()]);
}

export function dateToHuman(
  dateString,
  options = { year: "numeric", month: "long", day: "numeric" }
) {
  if (/\d{2}\.\d{2}\.\d{4}/.test(dateString)) {
    const dateParts = dateString.split(".").map(part => parseInt(part));

    const date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    return date.toLocaleDateString("ru-RU", options);
  }

  return "";
}
